var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { Input, Button } from 'Components.Form';
import { FormattedMessage, useIntl } from 'react-intl';
import { ProcessStepContainer, ProcessStepHeader, ProcessStepHeaderInfo, ProcessStepLabel, ProcessStepSubtitle } from '../../ProcessStep/components';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: .5rem;\n  border-radius: 3px;\n  background-color: #fafafa;\n  display: flex;\n  flex-flow: column;\n"], ["\n  padding: .5rem;\n  border-radius: 3px;\n  background-color: #fafafa;\n  display: flex;\n  flex-flow: column;\n"])));
var Row = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1rem;\n"])));
var Label = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 600;\n  margin-bottom: .25rem;\n"], ["\n  font-weight: 600;\n  margin-bottom: .25rem;\n"])));
var HealthCheckFailureReasonsStep = function (_a) {
    var deviceHealthChecks = _a.deviceHealthChecks, onChange = _a.onChange, baseId = _a.baseId, onConfirm = _a.onConfirm;
    var formatMessage = useIntl().formatMessage;
    var handleReasonChanged = function (key, reason) {
        onChange(deviceHealthChecks.map(function (check) { return (check.key === key
            ? __assign(__assign({}, check), { reason: reason }) : check); }));
    };
    if (!deviceHealthChecks || deviceHealthChecks.length === 0)
        return null;
    var allReasonsEntered = deviceHealthChecks.filter(function (check) { return !check.valid; }).every(function (_a) {
        var reason = _a.reason;
        return (reason !== null && reason !== void 0 ? reason : '').trim().length > 0;
    });
    return (React.createElement(ProcessStepContainer, { stepLevel: 2 },
        React.createElement(ProcessStepHeader, null,
            React.createElement(ProcessStepHeaderInfo, null,
                React.createElement(ProcessStepLabel, null,
                    React.createElement(FormattedMessage, { id: 'common.stepLabel', values: { stepNumber: 2 } })),
                React.createElement(ProcessStepSubtitle, null,
                    React.createElement(FormattedMessage, { id: 'deviceHealthCheckFailures.description' })))),
        deviceHealthChecks.filter(function (check) { return !check.valid; }).map(function (check, index) { return (React.createElement(Row, { key: check.key },
            React.createElement(Label, { htmlFor: "".concat(baseId, "_").concat(check.key) },
                React.createElement(FormattedMessage, { id: "deviceHealthCheckFailures.".concat(check.key) })),
            React.createElement(Input, { id: "".concat(baseId, "_").concat(check.key), value: check.reason, onChange: function (e) { return handleReasonChanged(check.key, e.target.value); }, placeholder: formatMessage({ id: "deviceHealthCheckFailures.placeholder" }) }))); }),
        React.createElement(Button, { id: "".concat(baseId, "_confirm_button"), success: true, disabled: !allReasonsEntered, onClick: onConfirm },
            React.createElement(FormattedMessage, { id: 'common.confirm' }))));
};
export default HealthCheckFailureReasonsStep;
var templateObject_1, templateObject_2, templateObject_3;
